import { Loading } from "@components/common/Loading";
import { FormInstanceRenderer } from "@nomena-raminoheritiana/front-form-builder";
import { Alert, Box } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import {  type FC } from "react";
import { useLanguage } from "../../../../contexts/LanguageContext";
import translations from "./translations.json";

type SupportedLanguage = keyof typeof translations;

export interface OfferAssesmentFormProps {
  onSubmit?: (data: any) => void;
  defaultValue?: any;
  formBuilderAccessToken: string | null;
  successMessage?: string;
  loading?: boolean;
}

const DARK_BORDER = "#1e2638";
const FIELD_BG = "#161d2b";

const OfferAssesmentForm: FC<OfferAssesmentFormProps> = ({
  onSubmit,
  defaultValue,
  formBuilderAccessToken,
  successMessage,
  loading
}) => {
  const { language } = useLanguage();
  const content = translations[language as SupportedLanguage] || translations.en;

  const handleAfterSubmit = async (data: any) => {
    if (onSubmit) {
      await onSubmit(data);
    }
    enqueueSnackbar(successMessage || content.success, { variant: 'success' });
  };

  return (
    <Box
      sx={{
        color: "#ffffff",

        /* 1. Labels de formulaires */
        "& label, & .MuiInputLabel-root": {
          color: "#8c94a4 !important"
        },

        /* 2. Style des champs de saisie (Standard + Disabled) */
        "& input, & textarea, & .MuiSelect-select": {
          color: "#ffffff !important",
          backgroundColor: `${FIELD_BG} !important`,
          WebkitTextFillColor: "#ffffff !important" /* Force la couleur du texte sur Safari/Chrome même si désactivé */
        },

        /* 3. Forcer le texte lisible pour les champs désactivés (Disabled / ReadOnly) */
        "& .Mui-disabled, & input:disabled, & textarea:disabled": {
          color: "#e2e8f0 !important",
          WebkitTextFillColor: "#e2e8f0 !important",
          opacity: "1 !important"
        },

        /* 4. Couleurs des Placeholders */
        "& input::placeholder, & textarea::placeholder": {
          color: "#64748b !important",
          opacity: "1 !important"
        },

        /* 5. Bordures et Conteneurs des inputs */
        "& .MuiOutlinedInput-root": {
          backgroundColor: `${FIELD_BG} !important`,
          borderRadius: "8px"
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: `${DARK_BORDER} !important`
        },
        "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: "#3b82f6 !important"
        },

        /* 6. Textes généraux */
        "& .MuiTypography-root": {
          color: "#ffffff"
        }
      }}
    >
      <Alert severity="warning" sx={{ mt: 1, color: '#ffe0a3', backgroundColor: 'rgba(255, 167, 38, 0.12)', '& .MuiAlert-icon': { color: '#ffb74d' } }}>
          {content.warningMessage}
      </Alert>
      {loading ? (
        <Loading />
      ) : (
        <FormInstanceRenderer 
          formInstanceId={`${import.meta.env.VITE_OFFER_ASSESMENT_FORM_INSTANCE_ID}`}
          defaultValues={defaultValue}
          showUnnamedFields={false}
          accessToken={formBuilderAccessToken || undefined}
          formLoader={() => <Loading />}
          onSubmit={(data) => {
            handleAfterSubmit(data);
          }}
          lang={language}
        />
      )}
      
    </Box>
  );
};

export default OfferAssesmentForm;